function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14 19C16.2125 19 18 20.7875 18 23C18 25.2125 16.2125 27 14 27C11.7875 27 10 25.2125 10 23C10 20.7875 11.7875 19 14 19ZM23.5 25C24.163 25 24.7989 25.2634 25.2678 25.7322C25.7366 26.2011 26 26.837 26 27.5C26 28.163 25.7366 28.7989 25.2678 29.2678C24.7989 29.7366 24.163 30 23.5 30C22.837 30 22.2011 29.7366 21.7322 29.2678C21.2634 28.7989 21 28.163 21 27.5C21 26.837 21.2634 26.2011 21.7322 25.7322C22.2011 25.2634 22.837 25 23.5 25ZM24 10C24.7879 10 25.5681 10.1552 26.2961 10.4567C27.0241 10.7583 27.6855 11.2002 28.2426 11.7574C28.7998 12.3145 29.2418 12.9759 29.5433 13.7039C29.8448 14.4319 30 15.2121 30 16C30 19.3125 27.3125 22 24 22C22.4087 22 20.8826 21.3679 19.7574 20.2426C18.6321 19.1174 18 17.5913 18 16C18 12.6875 20.6875 10 24 10Z",
  fill: "#FBFAFF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: -9.83407e-7,
  y1: 40,
  x2: 43.3889,
  y2: 4.09535,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#21A6C4"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#39DEB7"
})));

var SvgDataIcon = function SvgDataIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDataIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data-icon.87f65c01.svg";
export { ForwardRef as ReactComponent };